module.exports = __webpack_public_path__ + "img/i2.bdf9d429.png";